import { render } from "./roadmapScreen.vue?vue&type=template&id=49ff445c"
import script from "./roadmapScreen.vue?vue&type=script&lang=js"
export * from "./roadmapScreen.vue?vue&type=script&lang=js"

import "./roadmapScreen.vue?vue&type=style&index=0&id=49ff445c&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__